import { render, staticRenderFns } from "./expertQuestionView.vue?vue&type=template&id=0184aec5&scoped=true"
import script from "./expertQuestionView.vue?vue&type=script&lang=js"
export * from "./expertQuestionView.vue?vue&type=script&lang=js"
import style0 from "./expertQuestionView.vue?vue&type=style&index=0&id=0184aec5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0184aec5",
  null
  
)

export default component.exports